export default "__VITE_ASSET__BGxS3uaY__"